export const enum RemoveUsersConfirmationDialogActions {
    REMOVE = 'remove',
    CANCEL = 'cancel',
}
